import { $host } from '../../libs/user-api'
import _ from 'lodash'
import moment from 'moment'

export default {
  state: {
    lines: [],
    LPUList: [],
    failed: [],
    progress: { done: 0, total: 0 },
  },
  mutations: {
    updateProgress(state, progress) {
      state.progress = progress
    },
    // строки добавляются по мере ответов учреждений, а не одним куском
    addReport(state, lines) {
      state.lines = [...state.lines, ...lines]
    },
    updateFailed(state, failed) {
      state.failed = failed
    },
    updateLPUList(state, sockets) {
      state.LPUList = sockets.map((s) => ({
        bpId: s.bpId,
        title: s.title,
        online: s.online,
      }))
    },
    clearLines(state) {
      state.lines = []
    },
  },
  actions: {
    async getSockets(ctx) {
      let resposne = await $host.get(`/api/sockets`)
      ctx.commit('updateLPUList', resposne.data)
    },

    // Данные нигде не хранятся: на каждое учреждение уходит живой SQL в его MSSQL через сокет
    async getReports(ctx, { bpIds, date, view }) {
      const dateStr = moment(date, 'YYYY-MM').format('YYYY-MM-DD')
      ctx.commit('clearLines')
      ctx.commit('updateFailed', [])
      ctx.commit('updateProgress', { done: 0, total: bpIds.length })
      const failed = []
      await Promise.all(
        bpIds.map(async (bpId) => {
          try {
            const response = await $host.get(`/api/report?view=${view}&bpId=${bpId}&date=${dateStr}`)
            // при отвалившемся клиенте сервер отдаёт строку 'socket not found' или строку без даты
            const lines = Array.isArray(response.data) ? response.data.filter((l) => l && l.start_int) : []
            if (!lines.length) throw new Error('no data')
            ctx.commit('addReport', lines)
          } catch (e) {
            const lpu = ctx.state.LPUList.find((l) => l.bpId == bpId)
            failed.push(lpu ? lpu.title : bpId)
          } finally {
            ctx.commit('updateProgress', { done: ctx.state.progress.done + 1, total: bpIds.length })
          }
        }),
      )
      ctx.commit('updateFailed', failed)
    },
  },
  getters: {
    getStatistics(state) {
      return _.sortBy(state.lines, 'title')
    },
    failedLPU(state) {
      return state.failed
    },
    reportProgress(state) {
      return state.progress
    },
    LPUList(state) {
      return state.LPUList.filter((l) => l.online == 'true')
    },
  },
}
